var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyRub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136709)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1221 0H-8V15.3393H38.1221V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1221 15.3389H-8V30.6781H38.1221V15.3389Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1221 10.2261H-8V20.4522H38.1221V10.2261Z",
    fill: "#0039A6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    stroke: "#E5E5E5",
    strokeWidth: 1.44114,
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136709"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136709"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRub);
export default __webpack_public_path__ + "static/media/Currency=RUB.113631780f97d1ae817eba10ae01504f.svg";
export { ForwardRef as ReactComponent };